import { render } from "./TutorialDetail.vue?vue&type=template&id=5996889e&scoped=true"
import script from "./TutorialDetail.vue?vue&type=script&lang=js"
export * from "./TutorialDetail.vue?vue&type=script&lang=js"

import "./TutorialDetail.vue?vue&type=style&index=0&id=5996889e&scoped=true&lang=scss"
import "./TutorialDetail.vue?vue&type=style&index=1&id=5996889e&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5996889e"]])

export default __exports__